/*
 * @Author: lixin jiang
 * @Date: 2021-07-07 10:57:29
 * @LastEditTime: 2021-07-13 19:37:00
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/arcInput/index.js
 * @
 */
import ArcInput from './arcInput';

export default ArcInput;
